import { BankDetailProps } from 'app/dataTypes/account/bankDetails/BankDetailsTypes'

import type { Request } from '../../index'


type ResultAPI = {
  bank_title: string
  bik: string
  checking_account: string
  corr_account: string
}

export const convertResult = ({
  bank_title: bankTitle,
  bik,
  checking_account: checkingAccount,
  corr_account: corrAccount,
}: ResultAPI): BankDetailProps => {
  return {
    bankTitle,
    bik,
    checkingAccount,
    corrAccount,
  }
}

export const GET_BANK_DETAILS: Request<void, BankDetailProps, void> = [
  'account/bank_details',
  'get',
  ['data', 'bank_details'],
]
